/**
 * The scene as the assistant's model reads it: the outline a hosted turn carries, and every tool result after it
 * (hosted-session.ts). The chat panel and the bench send the same text.
 */

import type { SceneObject, TraceScene } from 'trace-viewer/scene';
import { describeEditorFocus } from 'trace-viewer/editor';
import { formatPinnedChoices, gatherSceneContext, gatherSelectedObjectContext } from './agent-context';
import type { AssistantPins, MediaToggles } from './agent-types';
import { sandboxHost } from './tools/shared-scene-tools';

export interface SceneView {
    traceScene: TraceScene;
    selectedObject: SceneObject | null;
    pins: AssistantPins;
    toggles: MediaToggles;
}

/** The scene, the selection, what the editor has in focus (the States strip), and the user's pinned choices. */
export function sceneForModel({ traceScene, selectedObject, pins, toggles }: SceneView): string {
    let text = `## Current Scene\n${gatherSceneContext(traceScene, { overview: true })}\n`;
    if (selectedObject) text += `\n## Selected Object\n${gatherSelectedObjectContext(selectedObject)}\n`;
    const focus = describeEditorFocus(sandboxHost({ traceScene, selectedObject }));
    if (focus) text += `\n## Editor Focus\n${focus}\n`;
    const pinned = formatPinnedChoices(pins, toggles);
    if (pinned) text += `\n## Pinned Choices\n${pinned}\n`;
    return text;
}
